import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

// import '@ant-design/compatible/assets/index.css';


import {
  Form,
  Tabs,
  Card,
  Col,
  DatePicker,
  Input,
  Row,
  InputNumber,
  Typography,
  Divider,
  Spin,
} from 'antd';
import moment from 'moment';

import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';
import Text from 'components/Text';
import Checkbox from 'components/Checkbox';
import ParListSelect from 'components/ParListSelect';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import { getProposalById } from 'services/proposal';
import InputCurrency from 'components/InputCurrency';
import InputRate from 'components/InputRate';
import GuaranteesTable from 'pages/ProposalV3/PropDetail/GuaranteesTable';
import { isNil, maxBy, sumBy } from 'lodash';
import { getScoringFileList } from 'services/scoring';
import GetLabel from 'DisplayFramework/components/GetLabel';

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Text: AntText } = Typography;

export type TabDecisionProps = {
  objectid?: number;
  form?: FormInstance;
  setSuccessful?: any;
};

const TabDecision = ({ objectid, form, setSuccessful }: TabDecisionProps) => {
  const [state, setState] = useState<any>({
    assets: [],
    CONTRACT: {},
    guaranty: [],
    insurance: [],
    currcode: localStorage.getItem('currcode') ?? '',
  });
  const { data, refetch, isFetching } = useQuery(
    ['getProposalById', { ctrid: objectid }],
    () => getProposalById({ ctrid: objectid! }).then((res) => res.data),
    { enabled: isNil(objectid) }
  );
  const { data: scoring, refetch: refet } = useQuery(
    ['getScoringFileList', { objectid }],
    () =>
      getScoringFileList({ objectid: objectid!, objecttype: 'PROPOSAL' }).then(
        (res) => res.list || []
      ),
    {
      enabled: !isNil(objectid),
    }
  );

  const lastScoanalystopinionlabelValues = scoring
  ? scoring[0]?.scoanalystopinionlabel
  : '';


  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (data) {
      const { assets } = data;

      const elemFINFinServ = data.conElements.filter(
        (element) => element.ctetype === 'FIN'
      );


      form?.setFieldsValue({
        reqfinamount: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'ctefinancedamount'
        ),
        finamountapproved: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'ctefinancedamount'
        ),
        reqinvestamount: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'cteinvestamount'
        ),
        investamountapproved: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'cteinvestamount'
        ),
        requpfront: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'cteupfrontamount'
        ),
        upfrontapproved: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'cteupfrontamount'
        ),
        rate:
          elemFINFinServ[0].ctecalculationtype === 'PREFIN'
            ? maxBy(
                !isNil(elemFINFinServ) ? elemFINFinServ : [],
                'ctenominalrate'
              )?.prefinnominalrate
            : maxBy(
                !isNil(elemFINFinServ) ? elemFINFinServ : [],
                'ctenominalrate'
              )?.ctenominalrate,
        rateapproved:
          elemFINFinServ[0].ctecalculationtype === 'PREFIN'
            ? maxBy(
                !isNil(elemFINFinServ) ? elemFINFinServ : [],
                'ctenominalrate'
              )?.prefinnominalrate
            : maxBy(
                !isNil(elemFINFinServ) ? elemFINFinServ : [],
                'ctenominalrate'
              )?.ctenominalrate,
        duration: maxBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'cteduration'
        )?.cteduration,
        durationapproved: maxBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'cteduration'
        )?.cteduration,

        firstpayment: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'ctefirstpayment'
        ),
        firstpaymentapproved: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'ctefirstpayment'
        ),

        residualvalue: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'ctervamount'
        ),
        residualvalueapproved: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'ctervamount'
        ),
        depositapproved: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'ctedepositamount'
        ),
        deposit: sumBy(
          !isNil(elemFINFinServ) ? elemFINFinServ : [],
          'ctedepositamount'
        ),
        decdate: moment(),
        declevel: data.ctdecisionlevel,
        dectype: 'MANUAL',
      });

      setState((prev: any) => ({
        ...prev,
        assets,
        currcode: data.currcode,
        CONTRACT: data,
      }));
    }
    if(scoring){
   
    const lastscoapprouvedamount= scoring ? scoring[0]?.scoapprouvedamount : 0; 
      form?.setFieldValue('lastscoapprouvedamount',lastscoapprouvedamount);
    }
  }, [data, scoring,form]);


  return (
    (<DF.Provider pagcode="tabdecision">
      <Spin spinning={isFetching}>
        <Row gutter={5}>
          <Col span={19}>
            <Card size="small" type="inner" title={<GetLabel label="Decision"/>} bordered>
              <Row gutter={[8, 8]}>
                <Col xs={12}>
                  <FormInput name="deccode" rules={[{ required: true }]}>
                    <ParListSelect parcode="DECISION" />
                  </FormInput>
                </Col>
                <Col xs={12}>
                  <FormInput name="decdate" rules={[{ required: true }]}>
                    <DatePicker />
                  </FormInput>
                </Col>
              </Row>

              <Tabs animated defaultActiveKey="1">
                <TabPane tab={<GetLabel label="Financial"/>} key={1} forceRender>
                  <Row gutter={[8, 8]}>
                    <Col span={4}>
                      <Text comcode="reqinvestamount" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="reqinvestamount">
                        <InputCurrency currcode={state.currcode} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="investamountreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="investamountreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Text comcode="investamountapproved" />
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="investamountapproved"
                      >
                        <InputCurrency currcode={state.currcode} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={4}>
                      <Text comcode="upfront" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="requpfront">
                        <InputCurrency currcode={state.currcode} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="upfrontreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="upfrontreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Text comcode="upfrontapproved" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="lastscoapprouvedamount">
                        <InputCurrency currcode={state.currcode}/>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={4}>
                      <Text comcode="reqfinamount" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="reqfinamount">
                        <InputCurrency currcode={state.currcode} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="finamountreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="finamountreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Text comcode="finamountapproved" />
                    </Col>
                    <Col span={5}>
                      <Form.Item style={{ margin: 0 }} name="finamountapproved">
                        <InputCurrency currcode={state.currcode} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={4}>
                      <Text comcode="rate" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="rate">
                        <InputRate disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="ratereserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="ratereserve" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Text comcode="rateapproved" />
                    </Col>
                    <Col span={5}>
                      <Form.Item style={{ margin: 0 }} name="rateapproved">
                        <InputRate />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={4}>
                      <Text comcode="duration" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="duration">
                        <InputNumber disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="durationreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="durationreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Text comcode="durationapproved" />
                    </Col>
                    <Col span={5}>
                      <Form.Item style={{ margin: 0 }} name="durationapproved">
                        <InputNumber />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={4}>
                      <Text comcode="firstpayment" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="firstpayment">
                        <InputCurrency currcode={state.currcode} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="firstpaymentreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="firstpaymentreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Text comcode="firstpaymentapproved" />
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="firstpaymentapproved"
                      >
                        <InputCurrency currcode={state.currcode} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={4}>
                      <Text comcode="residualvalue" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="residualvalue">
                        <InputCurrency currcode={state.currcode} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="residualvaluereserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="residualvaluereserve" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Text comcode="residualvalueapproved" />
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="residualvalueapproved"
                      >
                        <InputCurrency currcode={state.currcode} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={4}>
                      <Text comcode="deposit" />
                    </Col>
                    <Col span={6}>
                      <Form.Item style={{ margin: 0 }} name="deposit">
                        <InputCurrency currcode={state.currcode} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="depositreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="depositreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Text comcode="depositapproved" />
                    </Col>
                    <Col span={5}>
                      <Form.Item style={{ margin: 0 }} name="depositapproved">
                        <InputCurrency currcode={state.currcode} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab={<GetLabel label="Asset"/>} key={2} forceRender>
                  <Row>
                    <Col span={4}><GetLabel label="List of Assets :"/></Col>
                    <Col span={20}>
                      {state.assets.map((asset: any, index: any) => (
                        <Row key={index}>
                          <Col span={20}>{asset.assetlabel}</Col>
                          <Col span={4}>
                            {toCurrency(asset.assetnetamount, state.currcode)}
                          </Col>
                        </Row>
                      ))}
                    </Col>
                  </Row>
                  <Divider><GetLabel label="Reserves"/></Divider>
                  <Row>
                    <Col span={4}>
                      <Form.Item
                        name="assetreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="assetreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={20}>
                      <Form.Item name="assetnote">
                        <TextArea rows={6} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab={<GetLabel label="Guaranty"/>} key={3} forceRender>
                  <Row>
                    <GuaranteesTable ctrid={objectid} display />
                  </Row>
                  <Divider><GetLabel label="Reserves"/></Divider>
                  <Row>
                    <Col span={4}>
                      <Form.Item
                        name="warrantyreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="warrantyreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={20}>
                      <Form.Item name="warrantynote">
                        <TextArea rows={6} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tab={<GetLabel label="Insurances"/>} key={4} forceRender>
                  <Row>
                    <Col span={4}><GetLabel label="List of Insurances :"/></Col>
                    <Col span={20}>
                      {state.insurance.map((e: any, index: any) => (
                        <Row key={index}>
                          <Col span={20}>{e.instypelabel}</Col>
                          <Col span={4}>
                            {toCurrency(e.insamount, state.currcode)}
                          </Col>
                        </Row>
                      ))}
                    </Col>
                  </Row>
                  <Divider><GetLabel label="Reserves"/></Divider>
                  <Row>
                    <Col span={4}>
                      <Form.Item
                        name="insurancereserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="insurancereserve" />
                      </Form.Item>
                    </Col>
                    <Col span={20}>
                      <Form.Item name="insurancenote">
                        <TextArea rows={6} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tab={<GetLabel label="Coborrower"/>} key={5} forceRender>
                  <Row>
                    <Col span={4}><GetLabel label="Coborrower"/></Col>
                    <Col span={20}>{state.CONTRACT.cobname}</Col>
                  </Row>
                  <Divider><GetLabel label="Reserves"/></Divider>
                  <Row>
                    <Col span={4}>
                      <Form.Item
                        name="coborrowerreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="coborrowerreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={20}>
                      <Form.Item name="coborrowernote">
                        <TextArea rows={6} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tab={<GetLabel label="Guarantor"/>} key={6} forceRender>
                  <Row>
                    <Col span={4}><GetLabel label="Guarantor"/></Col>
                    <Col span={20}>{state.CONTRACT.guarantorname}</Col>
                  </Row>
                  <Divider><GetLabel label="Reserves"/></Divider>
                  <Row>
                    <Col span={4}>
                      <Form.Item
                        name="guarantorreserve"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox comcode="guarantorreserve" />
                      </Form.Item>
                    </Col>
                    <Col span={20}>
                      <Form.Item name="guarantornote">
                        <TextArea rows={6} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tab={<GetLabel label="Notes & comments"/>} key={7} forceRender>
                  <FormInput name="deccomment">
                    <TextArea rows={6} />
                  </FormInput>
                </TabPane>
              </Tabs>
            </Card>
          </Col>
          <Col span={5}>
            <Card size="small" type="inner" title={<GetLabel label="Last Decision"/>} bordered>
              <FormInput comcode="deccode" noMargin>
                <AntText type="warning" strong>
                  {state.CONTRACT.ctdecisioncodelabel}
                </AntText>
              </FormInput>

              <FormInput name="dectype" noMargin>
                <AntText type="warning" strong>
                  {state.CONTRACT.ctdecisiontype}
                </AntText>
              </FormInput>

              <FormInput name="declevel" noMargin>
                <AntText type="warning" strong>
                  {state.CONTRACT.ctdecisionlevellabel}
                </AntText>
              </FormInput>

              <FormInput comcode="decdate" noMargin>
                <AntText type="warning" strong>
                  {state.CONTRACT.ctdecisiondate}
                </AntText>
              </FormInput>

              <FormInput comcode="ctdecisioncomment" noMargin>
                <AntText type="warning" strong>
                  {String(state?.CONTRACT?.ctdecisioncomment ?? '')
                    ?.replace(/\n+/g, '\n')
                    ?.replace('null', '')
                    ?.split('\n')
                    ?.map((line, index) => (
                      <span key={index}>
                        {' - ' + line} <br />
                      </span>
                    ))}
                </AntText>
              </FormInput>

              <FormInput comcode="scoanalystopinionlabel">
                <AntText type="warning" strong>
                  {lastScoanalystopinionlabelValues}
                </AntText>
              </FormInput>
            </Card>
          </Col>
        </Row>
      </Spin>
    </DF.Provider>)
  );
};
export default TabDecision;
